import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormControl, InputGroup } from "react-bootstrap";
import { HiOutlineSearch } from "react-icons/hi";

import { Manifest } from "services/action";
import { formatDate } from "utilities/common";

import { Ticket, LoadingScreen } from "ui/components";
import { EmptyScreen } from "ui/components";

const RiwayatManifest = ({ tabKey }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Manifest.Get"]
  );

  const [data, setData] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [isEmpty, setEmpty] = React.useState(false);

  const $onLoad = async () => {
    const req = await Dispatch(Manifest.$get(params()));

    if (req?.message === "success") {
      if (req?.data) {
        setData(req?.data);
        setEmpty(false);
      } else {
        setEmpty(true);
      }
    }
  };

  const params = () => {
    let query = {
      page: 1,
      limit: 100,
      status: "completed",
    };

    if (search) {
      query.search = search;
    }

    return query;
  };

  React.useEffect(() => {
    if (tabKey !== 'manifest') {
      return
    }

    $onLoad();
  }, [tabKey]);

  React.useEffect(() => {
    if (search === "") {
      $onLoad();
    }
  }, [search]);

  if (StateLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="pb-5">
      <div className="px-3 py-2">
        <InputGroup className="search flex-nowrap input-group-flat  bg-white">
          <FormControl
            placeholder="Cari kode manifest"
            value={search}
            onChange={(input) => setSearch(input.target.value)}
            className="bg-white"
          />
          <div className="input-group-text ps-2" onClick={() => $onLoad()}>
            <HiOutlineSearch />
          </div>
        </InputGroup>
      </div>
      {isEmpty ? (
        <EmptyScreen text="Data tidak ditemukan" />
      ) : (
        <div className="px-3 py-2">
          {data?.map((d, i) => (
            <Ticket
              key={i}
              code={d?.code}
              date={formatDate(d?.completed_at, "DD/MM/YYYY")}
              shipment={`Total Pengiriman (${d?.legs_count?.completed})`}
              type={d?.type}
              onClick={() => History.push(`/manifest/${d?.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RiwayatManifest;
